import SvgImage from '@/components/Module/SvgImage';
import React, { PropsWithChildren, ReactNode } from 'react';
import { AddInnerButton } from './styles';
import { SxProps } from '@mui/material';

interface AddAttendeeButtonProps extends PropsWithChildren {
  onClick: () => void;
  isMobile?: boolean;
  sx?: SxProps;
  extraComponent?: ReactNode;
}

const AddAttendeeButton: React.FC<AddAttendeeButtonProps> = ({
  onClick,
  sx,
  children,
  extraComponent,
}) => {
  return (
    <>
      <AddInnerButton onClick={onClick} sx={sx}>
        <SvgImage name={'plus_12'} />
        {children}
      </AddInnerButton>
      {extraComponent}
    </>
  );
};

export default AddAttendeeButton;
